import { useEffect, useState } from 'react';
import type { HeadsetDevice } from '../types/device';
import { subscribeToHeadsetDevices } from '../services/firebase/headsetDevices';

/**
 * Subscribes to paired headset devices for a user.
 */
export function useHeadsetDevices(uid?: string | null): HeadsetDevice[] {
  const [devices, setDevices] = useState<HeadsetDevice[]>([]);

  useEffect(() => {
    if (!uid) {
      setDevices([]);
      return undefined;
    }

    const unsubscribe = subscribeToHeadsetDevices(uid, setDevices);
    return () => unsubscribe();
  }, [uid]);

  return devices;
}
